import React, { useEffect, useState } from "react";
import { combineProps } from "../../../../helpers/objectHelper";
import { ChatBlock } from "./ChatBlock";
import { MessageInput } from "./MessageInput";
import { MessageTools } from "./MessageTools";

export function ChatFooter(props) {
  const { chatTemplate, chatBlock, settings, currentChat, clientKey, connected, hubConnection, eventId } = props;
  const { footer, primaryColor, sendButtonColor } = chatTemplate;


  const [text, setText] = useState("");
  const onTyping = (t, emoji = false) => {
    setText(emoji ? (text ? text + t : t) : t);
  };

  useEffect(() => {
    document.addEventListener("keyup", onEnterKeyPressed);
    return () => {
      document.removeEventListener("keyup", onEnterKeyPressed);
    };
  }, [text]);

  const onEnterKeyPressed = (e) => {
    var e = e || window.event; // for IE to cover IEs window event-object
    if (e.which == 13 && text) {
      sendMessage();
    }
  };
  const sendMessage = (message) => {
    if (!connected || !hubConnection || hubConnection.connectionState != 1) return;
    const { currentChat, chatAdmin, chatAlias } = props;

    let target = currentChat == "ALL" ? null : currentChat;
    let room = props.channel;
    let isValid = text && text.length <= 500;
    if (hubConnection && (isValid || message)) {
      hubConnection.invoke(
        "sendChatMessage",
        parseInt(eventId),
        clientKey,
        target,
        message ? (message == "VIDEO_CALL_INVITATION" ? "VIDEO_CALL_INVITATION" : "👍") : text,
        room,
        chatAlias || null,
        chatAdmin || false,
        target === 'ALL' || !target ? settings?.hideMessages ?? false : false
      );
      setText("");
    }
  };

  return (
    <div
      className="text-bar"
      style={{
        maxHeight: 50,
        background: footer.background,
        borderTop: `1px solid ${footer.borderColor}`,
      }}
    >
      {(chatBlock && currentChat == "ALL") || currentChat == "NONE" || currentChat == "NONE2" ? (
        <ChatBlock currentChat={currentChat} />
      ) : (
        <>
          <MessageInput {...combineProps([props, footer, { primaryColor, onTyping, text }])} />
          <MessageTools {...combineProps([props, footer, { primaryColor, sendButtonColor, onTyping, sendMessage, text }])} />
        </>
      )}
    </div>
  );
}
